import { get } from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import styled, { withTheme } from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';

import { Markdown } from '../utils/CustomMarkdown';
import LocationInfoStyle from './LocationInfoStyle';

const MapSpacer = styled.div`
    display: inline-block;
    width: 64px;
    margin-right: 14px;

    ${breakpoint.small} {
        width: 120px;
        margin-right: 23px;
    }
`;

class BaseLocationInfo extends PureComponent {
    static propTypes = {
        ab: PropTypes.shape({
            UseMarkdownForLocationInfoCard: PropTypes.string,
        }),
        fax: PropTypes.string,
        locationId: PropTypes.string,
        officeHours: PropTypes.array,
        officeHoursDict: PropTypes.object,
        phone: PropTypes.string,
        phoneExt: PropTypes.string,
        properties: PropTypes.object,
        selectedInsurance: PropTypes.object,
        trackClickIBubbleAcceptingNewPatients: PropTypes.func,
        trackClickIBubbleGeisingerHealthPlanExtra: PropTypes.func,
        trackClickIBubbleHandicapAccessible: PropTypes.func,
        trackClickIBubblePatientAgeRestrictions: PropTypes.func,
        trackClickIBubbleProvenHealthNavigatorLocation: PropTypes.func,
        trackClickIBubbleTier: PropTypes.func,
        trackClickIBubbleWheelchairAccessible: PropTypes.func,
        theme: PropTypes.object,
    };

    render() {
        const markdown = get(this.props.theme, 'profile.locationInfo.markdown');
        const definitions = get(this.props.theme, 'profile.definitions');
        const dataForMarkDown = {
            location: {
                phone: this.props.phone,
                fax: this.props.fax,
                officeHours: this.props.officeHours,
                officeHoursDict: this.props.officeHoursDict,
                ...this.props.properties,
            },
            insurance: { ...get(this.props, 'selectedInsurance.properties') },
        };

        return [
            <MapSpacer key="map" />,
            <LocationInfoStyle key="loc">
                {markdown ? (
                    <Markdown
                        data={dataForMarkDown}
                        definitions={definitions}
                        source={markdown}
                    />
                ) : null}
            </LocationInfoStyle>,
        ];
    }
}

export const LocationInfo = injectIntl(BaseLocationInfo);
export const LocationInfoView = withTheme(LocationInfo);
